import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, FormFeedback, Input } from "reactstrap";
import axios from "axios";

import Form from "./../../../general/Form/Form";

class EditCredentialModal extends Component {
  state = {
    invalidEmail: false
  };

  onFormSubmitHandler = () => {
    let state = {
      invalidEmail: false
    };
    this.setState(state);

    let email = this.emailRef.value;
    if (email) {
      const config = {
        headers: {
          "Content-Type": "application/json"
        }, 
        withCredentials: true
      };
      const data = {
        name: this.nameRef.value,
        email: email,
        company: this.companyRef.value,
        userId: this.props.userId
      };
      let credentialId = this.props.data[0];
      axios.put(`${process.env.REACT_APP_API_HOST}/credential/${credentialId}`, data, config).then((response) => {
        if (response.status === 200 && response.data.updated_credential.length > 0) {
          alert(`The credentials for ${data.name} was updated`);
          window.location.reload();
        }
      });
    }

    if (!email) state.invalidEmail = true;
    this.setState({
      ...state
    });
  };

  render() {
    const formStyle = {
      boxShadow: "none"
    };
    let credentialData = {
      name: null,
      email: null,
      company: null
    };
    if (this.props.data) {
      credentialData.name = this.props.data[1];
      credentialData.email = this.props.data[3];
      credentialData.company = this.props.data[2];
    }
    return (
      <Modal isOpen={this.props.show} toggle={this.props.toggleModal}>
        <ModalHeader toggle={this.props.toggleModal}>Edit Credential</ModalHeader>
        <ModalBody>
          <Form sectionStyle={formStyle} onSubmit={this.onFormSubmitHandler}>
            <FormGroup>
              <Label for="credentialName">Name</Label>
              <Input
                autoComplete="new-password"
                type="text"
                name="name"
                defaultValue={credentialData.name}
                innerRef={(el) => (this.nameRef = el)}
              />
            </FormGroup>
            <FormGroup>
              <Label for="credentialEmail">Email</Label>
              <Input
                autoComplete="new-password"
                type="email"
                name="email"
                defaultValue={credentialData.email}
                invalid={this.state.invalidEmail}
                innerRef={(el) => (this.emailRef = el)}
              />
              <FormFeedback>Credential must have an email.</FormFeedback>
            </FormGroup>
            <FormGroup>
              <Label for="credentialCompany">Company</Label>
              <Input type="text" name="company" defaultValue={credentialData.company} innerRef={(el) => (this.companyRef = el)} />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onFormSubmitHandler}>
            Save
          </Button>
          <Button color="secondary" onClick={this.props.toggleModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default EditCredentialModal;
